import clsx from 'clsx'
import { IToggleProps } from './types'
import sharedStyles from '@muiscss/sharedStyles.module.scss'
import styles from './styles.module.scss'

// TO DO CHECKBOXES AND RADIOS SHARE ALL CODE EXCEPT THE LABEL SCSS

const Toggle = ({
  alwaysOn,
  checked = false,
  disabled = false,
  id,
  label,
  labelPrefix,
  name,
  onBlur,
  onChange,
  onFocus,
  size = 'md',
  style,
  ...props
}: IToggleProps) => {
  return (
    <span className={clsx(styles.wrap, styles[size])} data-testid="mui-toggle" style={{ ...style }}>
      <input
        className={clsx('mui-toggle', styles.input)}
        data-testid={`mui-toggle-${id}`}
        defaultChecked={checked}
        disabled={disabled}
        id={id}
        name={name || `${id}-toggle`}
        onBlur={(event: React.FocusEvent<HTMLInputElement>) => onBlur?.(event)}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange?.(event)}
        onFocus={(event: React.FocusEvent<HTMLInputElement>) => onFocus?.(event)}
        type="checkbox"
        aria-checked={checked}
        role="switch"
        {...props}
      />
      <label
        className={clsx(styles.label, { [sharedStyles.disabled]: disabled })}
        data-testid={`test-toggle-label-${id}`}
        htmlFor={id}
        tabIndex={0}
      >
        {labelPrefix && <span data-style="text">{labelPrefix}</span>}
        <span data-style="toggle" className={clsx(styles.toggle, { [styles.alwaysOn]: alwaysOn })}>
          &nbsp;
        </span>
        {label && <span data-style="text">{label}</span>}
      </label>
    </span>
  )
}

export default Toggle
